import { Component, ElementRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store, select } from '@ngrx/store';
import { DataTablesModule } from 'angular-datatables';
import { ADTSettings } from 'angular-datatables/src/models/settings';
import { selectFundraiserReport } from 'app/manage-p2p/features/p2p.selectors';
import { Subject } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-p2p-pledges-report-tab',
  standalone: true,
  imports: [DataTablesModule],
  templateUrl: './p2p-pledges-report-tab.component.html',
  styleUrl: './p2p-pledges-report-tab.component.scss'
})
export class P2pPledgesReportTabComponent {
  @ViewChild('pledgesDatatable') datatableElement!: ElementRef;
  public typeData: any;
  public fundraisersReport: any;
  public dtOptions = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  public pledges: any[] = [];
  constructor(
    private store: Store,
  )
  {}
  
  public fundraiserReport: any = this.store.pipe(
    select(selectFundraiserReport),
    takeUntilDestroyed(),
  );

  ngOnInit(): void {
    this.fundraiserReport.subscribe(data => {
      this.fundraisersReport = data;
      if(this.fundraisersReport?.length > 0){
        this.typeData = this.fundraisersReport[0].campaignData;
      }

      this.pledges = this.transformFundraiserReport();

      this.renderDatatable();
    })
  }

  transformFundraiserReport(){
    return this.fundraisersReport
    .filter(item => item.pledges && item.pledges.length > 0)
    .flatMap(item =>
      item.pledges?.map(pledge => ({
        ...pledge,
        displayName: item.displayName,
        championInfo: item.userInfo,
      }))
    );
  }
  
  renderDatatable(){
    const self = this;
    this.dtOptions = {
      data: this.pledges,
      autoWidth: true,
      pageLength: 10,
      order: [[ 8, "desc" ]],
      fixedColumns: {
        left: 1,
      },
      paging: true,
      deferRender: true,
      destroy: true,
      dom: "<'table__header--paybee d-flex align-items-center justify-content-between pb-3 pt-3'<''B><''f>><'table-responsive't><'table__footer--paybee d-flex align-items-center justify-content-between p-4'ip>",
      buttons: [{
          className: 'btn-copy-code btn btn-outline-grey btn-sm px-2 waves-effect',
          extend: 'excel',
          filename: 'PeerToPeer_PledgesReport',
          text: "<i class='fas fa-cloud-download-alt mr-1'></i> Export",
          title: null,
          exportOptions: {
              stripHtml: true,
              columns: "thead th:not(.no-export)"
          }
      }],
      columns: [
        {
          data: 'donorInfo.name',
          render: function (name,type,row){
            if(type === 'display'){
              return `
                <div class="d-flex"
                  data-toggle="fullNameTooltip"
                  data-placement="top"
                  data-original-title="${name}"
                >
                    <span class="table-name-container">
                        ${name}
                    </span>
                </div>
              `
            }
  
            return name;
          }
        },
        {
          data: 'donorInfo.email',
        },
        {
          data: 'displayName',
        },
        {
          data: 'championInfo.name',
        },
        {
          data: 'championInfo.email',
        },
        {
          data: 'amount',
          type: "num-fmt",
          render: function(amount) {
              return window['utils'].getAmountDisplay(amount);
          }
        },
        {
          data: 'eventCount',
        },
        {
          data: 'donorInfo.address',
          defaultContent: "NA",
          render: function (donorInfo) {
            const address = donorInfo.address
            if (address && address.street1) {
              return window['utils'].getStreetAddressText(address, true)
            }
  
            return "NA";
          }
        },
        {
          data: 'donorInfo.phone',
          render : function (phone) {
            if(phone && phone != "") {
                return phone
            }
            
            return "NA"
          }
        },
        {
          data: 'created',
          type: 'date',
          render: function(date){
            return moment(date).format('YYYY/MM/DD h:mm A')
          }
        }
      ],
      drawCallback: function (){
        setTimeout(() => {
          window['dataTableService'].scrollCallback(window['$'](scrollContainer))

          window['$']('[data-toggle="fullNameTooltip"]')
            .filter(function () {
              const container = this.querySelector('.table-name-container');
              return container && container.scrollWidth > container.offsetWidth;
            })
            .tooltip();
          })
          
        const datatableEl = self.datatableElement.nativeElement as HTMLElement;
        const scrollContainer = datatableEl.parentElement;
    
        if (scrollContainer) {
          window['dataTableService'].registerScrollEvent(window['$'](scrollContainer));
        }
      },
      }
  
      setTimeout(() => {
        // race condition fails unit tests if dtOptions isn't sent with dtTrigger
        if (!this.dtTrigger.closed) {
          this.dtTrigger.next(this.dtOptions);
        }
      }, 200);
  }
}
